import React, { Component, MouseEvent } from 'react'

type ButtonType = 'primary' | 'secondary' | 'danger'
type ButtonsConfig = Record<ButtonType, ButtonConfig>

interface ButtonConfig {
  background: string
}

interface ButtonProps {
  text: string
  type?: ButtonType
  full?: boolean
  progress?: boolean
  onClick: (event: MouseEvent<HTMLButtonElement>) => void
  height?: number
}

export default class Button extends Component<ButtonProps> {
  buttons: ButtonsConfig = {
    primary: { background: 'bg-primary' },
    secondary: { background: 'bg-primary-light' },
    danger: { background: 'bg-danger' }
  }

  get className () {
    const { props } = this
    const base = 'bg-primary text-white capitalize focus:outline-none block py-2 px-5'
    const background = props.type && this.buttons[props.type].background
    const full = props.full && 'w-full'
    const progress = props.progress && 'cursor-wait'
    return `${base} ${background} ${full} ${progress}`
  }

  render () {
    return (
      <button
        style={this.props.height && this.props.height > 0 ? { height: this.props.height, marginTop: 23} : {width : undefined}}
        className={this.className}
        disabled={this.props.progress}
        onClick={this.props.onClick}>
        {this.props.text}
      </button>
    )
  }
}
